var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8773 20.5C9.61037 21.4144 10.7368 22 12 22C13.2632 22 14.3896 21.4144 15.1227 20.5H8.8773Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33541 2.67086C7.70589 2.48562 7.85606 2.03511 7.67082 1.66463C7.48558 1.29415 7.03507 1.14398 6.66459 1.32922L6.2423 1.54037C3.79555 2.76374 2.25 5.2645 2.25 8.00004C2.25 8.41426 2.58579 8.75004 3 8.75004C3.41421 8.75004 3.75 8.41426 3.75 8.00004C3.75 5.83266 4.97455 3.85129 6.91312 2.88201L7.33541 2.67086Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6646 2.67086C16.2941 2.48562 16.1439 2.03511 16.3292 1.66463C16.5144 1.29415 16.9649 1.14398 17.3354 1.32922L17.7577 1.54037C20.2044 2.76374 21.75 5.2645 21.75 8.00004C21.75 8.41426 21.4142 8.75004 21 8.75004C20.5858 8.75004 20.25 8.41426 20.25 8.00004C20.25 5.83266 19.0254 3.85129 17.0869 2.88201L16.6646 2.67086Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12.5523 2 13 2.44772 13 3V3.07893C16.0042 3.55805 18.3 6.16092 18.3 9.3V12.8394C18.3 13.6011 18.4895 14.3509 18.8514 15.0212L19.4068 16.0497C20.1264 17.3822 19.1614 19 17.647 19H6.35297C4.83857 19 3.87359 17.3822 4.59316 16.0497L5.14856 15.0212C5.5105 14.3509 5.7 13.6011 5.7 12.8394V9.3C5.7 6.16092 7.99584 3.55805 11 3.07893V3C11 2.44772 11.4477 2 12 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm4);
export default __webpack_public_path__ + "static/media/alarm-4.b03729d02fcc3ed3110727c619733f73.svg";
export { ForwardRef as ReactComponent };